var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1333 11.2C13.6667 11.2667 13.1333 11.3334 12.6667 11.3334C10.8667 11.3334 9.2 10.6667 7.93333 9.40002C5.73333 7.20002 5.33333 3.86669 6.93333 1.20002C7.06667 1.00002 7.06667 0.666687 6.93333 0.466687C6.8 0.266687 6.53333 0.133354 6.26667 0.20002C4.8 0.533354 3.4 1.26669 2.33333 2.33335C0.8 3.86669 0 5.86669 0 8.00002C0 10.1334 0.8 12.1334 2.33333 13.6667C3.86667 15.2 5.86667 16 8 16C10.1333 16 12.1333 15.2 13.6667 13.6667C14.0667 13.2667 14.4667 12.7334 14.8 12.2C14.9333 12 14.9333 11.6667 14.8 11.4667C14.6667 11.2 14.4 11.1334 14.1333 11.2Z",
    fill: "#0085FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0667 6.13333C14.8 5.8 14.6 5.26667 14.6 4.66667C14.6 4.06667 14.8 3.46667 15.1333 3.13333C15.2667 3 15.3333 2.86667 15.3333 2.66667C15.3333 2.46667 15.2667 2.33333 15.1333 2.2C14.8667 1.93333 14.4667 1.93333 14.2 2.2C13.8667 2.53333 13.2667 2.73333 12.6667 2.73333C12.0667 2.73333 11.4667 2.53333 11.1333 2.2C10.8667 1.93333 10.4667 1.93333 10.2 2.2C10.0667 2.33333 10 2.46667 10 2.66667C10 2.86667 10.0667 3 10.2 3.13333C10.5333 3.46667 10.7333 4.06667 10.7333 4.66667C10.7333 5.26667 10.5333 5.86667 10.2 6.2C10.0667 6.33333 10 6.46667 10 6.66667C10 6.86667 10.0667 7 10.2 7.13333C10.4667 7.4 10.8667 7.4 11.1333 7.13333C11.4667 6.8 12.0667 6.6 12.6667 6.6C13.2667 6.6 13.8667 6.8 14.2 7.13333C14.3333 7.26667 14.5333 7.33333 14.6667 7.33333C15.0667 7.33333 15.3333 7.06667 15.3333 6.66667C15.3333 6.46667 15.2667 6.26667 15.0667 6.13333Z",
    fill: "#0085FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.371ea99cff1b5092a94d555f04f17313.svg";
export { ForwardRef as ReactComponent };